import React from "react";

// Renders committed fences (red polylines + selection glow + hit area + editable
// vertex handles) and the in-progress fence draft. Pure presentational layer.
export default function FenceLayer({
  elements, selectedId, mode, tool, zoom, drawingFence,
  fenceDraft, fenceCursor, onSelect, onElementClick, onVertexDown, draftColor = "#FF0000",
}) {
  const z = zoom || 1;
  const fences = elements.filter((el) => el.kind === "fence" && el.points && el.points.length >= 2);
  const fenceColor = (el) => (el.fence_size === "small" ? "#F97316" : "#FF0000");

  return (
    <svg style={{ position: "absolute", left: 0, top: 0, overflow: "visible", pointerEvents: "none" }}>
      {fences.map((el) => {
        const sel = selectedId === el.id;
        const col = fenceColor(el);
        const pts = el.points.map((p) => `${p.x},${p.y}`).join(" ");
        return (
          <g key={`fence-${el.id}`}>
            {sel && (
              <polyline points={pts} fill="none" stroke="#FFC300" strokeWidth={9}
                vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" style={{ pointerEvents: "none" }} />
            )}
            <polyline points={pts} fill="none" stroke={col} strokeWidth={4}
              vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" style={{ pointerEvents: "none" }} />
            {/* wide invisible hit area */}
            <polyline data-testid={`map-element-${el.id}`} points={pts} fill="none" stroke="rgba(0,0,0,0.001)" strokeWidth={16}
              vectorEffect="non-scaling-stroke"
              style={{ pointerEvents: drawingFence ? "none" : "stroke", cursor: "pointer" }}
              onPointerDown={(e) => { e.stopPropagation(); }}
              onClick={(e) => { e.stopPropagation(); onSelect(el.id); if (onElementClick) onElementClick(el.id); }} />
            {/* editable vertex handles (admin, selected, select tool) */}
            {sel && mode === "admin" && tool === "select" && el.points.map((p, i) => (
              <circle key={`v-${el.id}-${i}`} cx={p.x} cy={p.y} r={6 / z}
                fill="#FFFFFF" stroke={col} strokeWidth={2 / z}
                style={{ pointerEvents: "all", cursor: "grab" }}
                onPointerDown={(e) => onVertexDown(e, el, i)} />
            ))}
          </g>
        );
      })}
      {/* in-progress fence draft */}
      {fenceDraft.length > 0 && (
        <>
          <polyline
            points={[...fenceDraft, ...(fenceCursor ? [fenceCursor] : [])].map((p) => `${p.x},${p.y}`).join(" ")}
            fill="none" stroke={draftColor} strokeWidth={4} strokeDasharray="8 5"
            vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
          {fenceDraft.map((p, i) => (
            <circle key={`draft-${i}`} cx={p.x} cy={p.y} r={5 / z} fill={draftColor} stroke="#fff" strokeWidth={2 / z} />
          ))}
        </>
      )}
    </svg>
  );
}
